import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { SpinnerService } from '../../../../base/spinner/spinner.service';
import { DataManager } from '@syncfusion/ej2-data';
import { AvpCustomAdaptor } from '../../../../base/shared/syncfusion/avp-custom-adaptor';
import { ExportInterfaceConfigTemplateDTO, ExportInterfaceConfigurationDTO, ExportInterfaceConfigurationMode, ExportInterfaceConfigurationType } from '../../../../base/models/models.swagger.generated';
import { RowSelectEventArgs, GridModule } from '@syncfusion/ej2-angular-grids';
import { ConfigurationTemplatesService } from '../../configuration-templates/configuration-templates.service';
import { ConfigurationFormCoordinatorService } from '../configuration-forms/configuration-form-coordinator.service';
import { ModalService } from '../../../../base/shared/modal/modal.service';
import { QueryBuilderModule } from '@syncfusion/ej2-angular-querybuilder';
import { CommonModule } from '@angular/common';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';

@Component({
    selector: 'app-configuration-templates-overview',
    templateUrl: './configuration-templates-overview.component.html',
    styleUrls: ['./configuration-templates-overview.component.scss'],
    imports: [
        GridModule,
        QueryBuilderModule,
        TranslateModule,
        CommonModule
    ]
})
export class ConfigurationTemplatesOverviewComponent extends GridBaseComponent<any> implements OnInit {

  @Input() public set configurationType(value: ExportInterfaceConfigurationType) {
    this.configurationTemplateService.configurationType = value;
    this.refresh();
  }

  @Input() public set mode(mode: ExportInterfaceConfigurationMode) {
    this.configurationTemplateService.mode = mode;
    this.refresh();
  }

  public get mode(): ExportInterfaceConfigurationMode {
    return this.configurationTemplateService.mode;
  }

  @Input() public isStandalone = false;

  @Output() rowSelected = new EventEmitter<any>();
  @Output() rowDoubleClick = new EventEmitter<any>();

  @Input() public set selectedTemplateId(value: number) {
    if (value !== this._selectedTemplateId) {
      this._selectedTemplateId = value;
      if (value !== null && value !== undefined) {
        this.grid?.selectRows([this.grid.getRowIndexByPrimaryKey(value)]);
      } else {
        this.grid?.selectRows([]);
      }
    }
  }

  private addedRecordId: number = null;
  private previousRowIndex: number;
  private _selectedTemplateId: number;

  constructor(
    translateService: TranslateService,
    protected configurationTemplateService: ConfigurationTemplatesService,
    private configurationFormCoordinatorService: ConfigurationFormCoordinatorService,
    private spinnerService: SpinnerService,
    private modalService: ModalService,
  ) {
    super(translateService, configurationTemplateService);
    this.addIndexFindColumnName = 'id';
  }

  ngOnInit() {
    this.configurationTemplateService.doIgnoreTypeFilter = this.isStandalone;
    this.isActiveColumnName = 'Active';
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.configurationTemplateService, this.spinnerService),
    });

    this.configurationTemplateService.oneTimeFilterTemplateId = this._selectedTemplateId;
  }

  public recordAdded(id: number) {
    this.addedRecordId = id;
    this.grid.refresh();
  }

  public onDataBound() {
    if (this.addedRecordId) {
      const index = this.grid?.getRowIndexByPrimaryKey(this.addedRecordId);
      this.grid?.selectRow(index);
      this.addedRecordId = null;
      if (this.previousRowIndex >= index) {
        this.previousRowIndex += 1;
      }
    }

    if (this._selectedTemplateId && this.grid?.selectedRowIndex < 0) {
      const index = this.grid?.getRowIndexByPrimaryKey(this._selectedTemplateId);
      this.grid?.selectRow(index);
    }
  }

  public refresh(): void {
    this.grid?.refresh();
  }

  public getTypeName(transferType: number): string {
    return 'i18n.shared.configurationTypes.' + ExportInterfaceConfigurationType[transferType];
  }

  public getModeName(mode: ExportInterfaceConfigurationMode): string {
    return 'i18n.shared.configuration-modes.' + ExportInterfaceConfigurationMode[mode];
  }

  public onRowSelected(args: RowSelectEventArgs): void {
    if (this.configurationFormCoordinatorService.isFormDirty()) {
      const dialog = this.modalService.showOkCancelDialog('i18n.domain.export-configuration.configurations.discard-dialog.title', 'i18n.domain.export-configuration.configurations.discard-dialog.question');
      dialog.onOkSubject.subscribe(() => {
        const data = args.data as ExportInterfaceConfigurationDTO;
        if (data) {
          this._selectedTemplateId = data.id;
          this.rowSelected.emit(data);
          this.previousRowIndex = this.grid?.selectedRowIndex;
        }
      });
      dialog.onCancelSubject.subscribe(() => {
        this.grid.selectRows([this.previousRowIndex]);
      });
    } else {
      const data = args.data as ExportInterfaceConfigurationDTO;
      if (data) {
        this._selectedTemplateId = data.id;
        this.rowSelected.emit(data);
        this.previousRowIndex = this.grid?.selectedRowIndex;
      }
    }
  }

  public onRowDoubleClick(args): void {
    if (this.configurationFormCoordinatorService.isFormDirty()) {
      const dialog = this.modalService.showOkCancelDialog('i18n.domain.export-configuration.configurations.discard-dialog.title', 'i18n.domain.export-configuration.configurations.discard-dialog.question');
      dialog.onOkSubject.subscribe(() => {
        const data = args.rowData as ExportInterfaceConfigTemplateDTO;
        if (data) {
          this.rowDoubleClick.emit(data);
        }
      });
    } else {
      const data = args.rowData as ExportInterfaceConfigTemplateDTO;
      if (data) {
        this.rowDoubleClick.emit(data);
      }
    }
  }

  public resetRowSelected(): void {
    if (this.grid?.selectedRowIndex >= 0) {
      this.grid.selectRows([]);
    }
  }

  protected initializeEditForm(data: ExportInterfaceConfigurationDTO): void {
    throw new Error('Method not implemented.');
  }

  protected getEditDialogTitleParams(rowData: any): object {
    throw new Error('Method not implemented.');
  }


}
